import React from 'react';
import PropTypes from 'prop-types';
import LabelInput from 'library/components/unstyled-input';

import 'apps/pathways/styles/start/main.scss';
class Skill extends React.PureComponent {
  render() {
    const { onChange, name, proficiency, active } = this.props;

    return (
      <div className="experiences-form-container">
        <section>
          <LabelInput
            label="Skill"
            required={active}
            disabled={!active}
            name="name"
            type="input"
            onChange={onChange}
            placeholder="Name"
            value={name}
            diffAriaLabel="Name of Skill"
          />

          <label htmlFor="proficiency">
            Proficiency
            <select
              aria-label="proficiency"
              required={active}
              disabled={!active}
              aria-required="true"
              onChange={onChange}
              value={proficiency}
              name="proficiency"
              id="proficiency"
            >
              <option value="">-</option>
              <option value={5}>5 - Very Proficient</option>
              <option value={4}>4</option>
              <option value={3}>3</option>
              <option value={2}>2</option>
              <option value={1}>1 - Not Proficient</option>
            </select>
          </label>
        </section>
      </div>
    );
  }
}

Skill.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string,
  proficiency: PropTypes.number,
  active: PropTypes.bool,
};

export default Skill;
